import { IS_COLOR_THEME_DARK as localStorageKey } from '../KEYS';

const StoredIsColorThemeDark = {
  get(): boolean {
    const raw = localStorage.getItem(localStorageKey);
    if (raw === null) return systemPrefersDark();
    return raw === JSON.stringify(true);
  },

  set(value: boolean): void {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  },
};

export default StoredIsColorThemeDark;

// Dark unless the OS asks for light — a "no preference" system lands on dark,
// the SSO product's default look.
function systemPrefersDark(): boolean {
  return !window.matchMedia('(prefers-color-scheme: light)').matches;
}
